import { useState } from 'react';
import { NetworkLinks } from '@/features/networks/NetworkLinks';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Tabs } from '@/ui';
import { Icon } from '@/icons';
import { DiscussionsTab } from './tabs/DiscussionsTab';
import { CollaborationsTab } from './tabs/CollaborationsTab';
import { InvitesTab } from './tabs/InvitesTab';
import { FeaturedCreatorsPanel } from './panels/FeaturedCreatorsPanel';
import { UpcomingEventsPanel } from './panels/UpcomingEventsPanel';

const Page = styled.div` min-height: 100vh; background: ${({ theme }) => theme.color.bgRoot}; `;
const Bar = styled.div` padding: 16px 24px; `;
const Body = styled.div` max-width: 1100px; margin: 0 auto; padding: 0 24px 64px; `;
const Head = styled.header` margin-bottom: 16px; `;
const TitleRow = styled.div` display: flex; align-items: center; gap: 10px; `;
const Title = styled.h1` margin: 0; font-family: ${({ theme }) => theme.font.display}; font-size: ${({ theme }) => theme.fontSize.xl}; color: ${({ theme }) => theme.color.textPrimary}; `;
const Pill = styled.span`
  display: inline-flex; align-items: center; gap: 4px; padding: 2px 10px; border-radius: ${({ theme }) => theme.radius.sm};
  font-size: ${({ theme }) => theme.fontSize.xs}; font-weight: 600; color: ${({ theme }) => theme.color.onAccent};
  background: ${({ theme }) => theme.color.accentCyan};
`;
const Sub = styled.p` margin: 4px 0 0; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted}; `;
const Grid = styled.div`
  display: grid; grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr); gap: 24px;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;
const Main = styled.div` min-width: 0; `;
const TabBody = styled.div` margin-top: 16px; `;
const Side = styled.aside` min-width: 0; `;

const TAB_ITEMS = [
  { value: 'discussions', label: 'Discussions' },
  { value: 'collaborations', label: 'Collaborations' },
  { value: 'invites', label: 'Invites' },
];

export function CreatorsHubLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [tab, setTab] = useState('discussions');
  function handleBack() {
    if (location.key === 'default') navigate('/');
    else navigate(-1);
  }
  return (
    <Page>
      <Bar>
        <Button variant="ghost" onClick={handleBack}><Icon name="arrow-left" size={16} /> Back</Button>
      </Bar>
      <Body>
        <NetworkLinks destination="creator" />
        <Head>
          <TitleRow>
            <Title>Creators&apos; Hub</Title>
            <Pill><Icon name="sparkles" size={14} /> Premium</Pill>
          </TitleRow>
          <Sub>Collaborate, discuss, and connect with other creators.</Sub>
        </Head>
        <Grid>
          <Main>
            <Tabs items={TAB_ITEMS} value={tab} onChange={setTab} />
            <TabBody>
              {tab === 'discussions' && <DiscussionsTab />}
              {tab === 'collaborations' && <CollaborationsTab />}
              {tab === 'invites' && <InvitesTab />}
            </TabBody>
          </Main>
          <Side>
            <FeaturedCreatorsPanel />
            <UpcomingEventsPanel />
          </Side>
        </Grid>
      </Body>
    </Page>
  );
}
